// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.property-label{font-weight:600;margin-bottom:10px}.property-value{line-height:1.4;overflow-wrap:anywhere}.property-value__empty{color:var(--uap-log-font-light-grey)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
